export const additionalSx = (theme:any, sx:any) => {
    if(!sx) {
      return {};
    }

    if(typeof sx === 'function') {
      return sx(theme);
    }

    return sx;
};
